import React from 'react';

import { Row, Col } from 'react-bootstrap-5';
import SearchInput from 'components/search_sidebar/sidebar_search';
import CompanyOfficeSelect from '../shared/company_office_select';

type FiltersProps = {
  searchTerm: string;
  onSetSearchTerm: (term: string) => void;
  onSelectOffice: (option: { value: string }) => void;
  officeOptions: Array<{ value: string; label: string }>;
};

const Filters = ({ searchTerm, onSetSearchTerm, onSelectOffice, officeOptions }: FiltersProps) => {
  return (
    <Row className="mb-3">
      <Col sm={6}>
        <label className="form-label mb-1" htmlFor="oup-user-name-filter">Search</label>
        <SearchInput
          inputProps={{ id: 'oup-user-name-filter' }}
          placeholder="Search by name"
          value={searchTerm}
          onChange={e => onSetSearchTerm(e.target.value)}
          onClear={() => onSetSearchTerm('')}
        />
      </Col>
      <Col sm={6}>
        <label className="form-label mb-1" htmlFor="oup-user-office-filter">Office</label>
        <CompanyOfficeSelect
          companyOfficeOptions={officeOptions}
          inputId="oup-user-office-filter"
          maxWidth="none"
          placeholder="Filter by office"
          onChange={onSelectOffice}
        />
      </Col>
    </Row>
  );
};

export default Filters;
